import React from "react";
import AddSheet from "assets/img/AddSheet.svg";

const ContainedButton = ({ OnClick, contentText, disabled }) => {
  return (
    <button
      style={{
        border: "1px solid " + (disabled ? '#10875750' : "#108757"),
        color: "#fff",
        width: "318px",
        height: "50px",
        background: disabled ? '#10875750' : "#108757",
      }}
      onClick={OnClick}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <img style={{ marginRight: "5px" }} src={AddSheet} />
        {contentText}
      </div>
    </button>
  );
};

export default ContainedButton;
